// src/components/common/SkeletonTable.jsx
import React from 'react'

export default function SkeletonTable({ rows = 5, columns = 4 }) {
    return (
        <div className="animate-pulse">
            <div className="space-y-4">
                {/* Header */}
                <div className="grid grid-cols-4 gap-4 mb-4">
                    {[...Array(columns)].map((_, i) => (
                        <div key={i} className="h-4 bg-black-200 rounded"></div>
                    ))}
                </div>
                {/* Rows */}
                {[...Array(rows)].map((_, rowIndex) => (
                    <div key={rowIndex} className="grid grid-cols-4 gap-4 py-3">
                        {[...Array(columns)].map((_, colIndex) => (
                            <div key={colIndex} className="h-4 bg-black-200 rounded"></div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    )
}